import React from 'react';
import Styles from './CourseView.module.scss'
import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { useAPI, ViewContext, useNavigate } from 'components/lib';
import { QuizQuestion } from 'components/global/QuizQuestion/QuizQuestion';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import DoneIcon from "@mui/icons-material/Done";
import { Dialog, DialogContent, DialogTitle, Tab, Tabs, Typography, Badge, Chip } from '@mui/material';
import { UserManual } from 'components/UserManual/UserManual';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import ReactPlayer from 'react-player'
import { toast, ToastContainer } from 'react-toastify';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';

//icons

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import QuizIcon from '@mui/icons-material/Quiz';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ReplayIcon from '@mui/icons-material/Replay';
import { useParams } from 'react-router-dom';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { useContext, useRef } from 'react';

import { Chart } from 'components/lib';

import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { Transcript } from 'components/global/LMS/Transcript/Transcript';




export function CourseView() {
    const { courseId } = useParams();
    const [showSections, setShowSections] = useState('');
    const [courseData, setCourseData] = useState([])
    const [lectureData, setLectureData] = useState({});
    const { data, loading } = useAPI(`/api/lms/courses/${courseId}/content`)
    const [lectureLoading, setLectureLoading] = useState(true)
    const [quesIndex, setQuesIndex] = useState(0)
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [isResults, setIsResults] = useState(false);
    const [isPlaying, setIsPlaying] = useState();
    const [courseComplete, setCourseComplete] = useState(false);
    const [pendingCourse, setPendingCourse] = useState(false);
    const [isLastLecture, setIsLastLecture] = useState(false);
    const [highlightNext, setHighlightNext] = useState(false);
    const [isLastLectureCompleted, setIsLastLectureCompleted] = useState(false);
    const [lectureProgress, setLectureProgress] = useState(0);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const viewContext = useContext(ViewContext);
    const [quizScore, setQuizScore] = useState({
        showPrevScore: false,
        percentage: 0,
        score: 0
    });
    const [disableNext, setDisableNext] = useState(false)
    const playerRef = useRef(null);
    // eslint-disable-next-line no-unused-vars
    let reportTemplateRef = useRef();
    const navigate = useNavigate();
    const handleAnswerSelect = (orderId, questId, selectedOption) => {
        setSelectedAnswers((prevSelectedAnswers) => {
            const updatedSelectedAnswers = [...prevSelectedAnswers];

            updatedSelectedAnswers[orderId] = {
                question_id: questId,
                selectedOption: selectedOption,
            };

            return updatedSelectedAnswers;
        });
    };

    useEffect(() => {
        if (data) {
            setCourseData(data?.courseData);
            setShowSections(data?.courseData[0].module_id)
            data.initialLectureData.module_id = data?.courseData[0].module_id
            setLectureData(data?.initialLectureData);
            setLectureLoading(false);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (lectureData) {
            setLectureProgress(lectureData?.progress);
            setIsLastLectureCompleted(lectureData.course_activity?.course_status === "pending" &&
                lectureData.course_activity?.pending_lecture_id?.length === 1
                && lectureData.id === lectureData.course_activity?.pending_lecture_id[0]);
            setIsLastLecture(lectureData.id === courseData?.slice(-1)[0]?.lectures?.slice(-1)[0].lecture_id);
        }

        if (lectureData?.type === 'quiz') {
            const attempted = lectureData?.lecture_status === 'Completed' || lectureData?.lecture_status === 'Retake';
            const showPrev = attempted && lectureData?.quizStats?.isAttempted;

            setQuizScore({
                showPrevScore: showPrev,
                percentage: showPrev ? (lectureData?.quizStats?.quizPercentage ?? 0) : 0,
                score: showPrev ? (lectureData?.quizStats?.quizScore ?? 0) : 0
            });
        }

        if ((lectureData?.type === 'user_manual' && lectureData?.content?.length - 1)
            || ['quiz', 'ai_quiz'].includes(lectureData?.type)) {
            setDisableNext(true)
        } else {
            setDisableNext(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lectureData]);

    useEffect(() => {
        if (lectureData?.type === 'user_manual') {
            if (lectureProgress === lectureData?.content?.length - 1) {
                setDisableNext(false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lectureProgress])

    function lectureSelect(module_id, lecture_id) {
        retakeQuiz();
        if (lectureData?.lecture_id === lecture_id && lectureData?.module_id === module_id) {
            return;
        }
        setLectureLoading(true)
        axios.post(`/api/lms/lectures/content/fetch?module_id=${module_id}&lecture_id=${lecture_id}&course_id=${courseId}`)
            .then(response => {
                // eslint-disable-next-line array-callback-return
                const serverStatus = response.data.data?.lecture_status;
                setCourseData(prevCourseData => prevCourseData.map(course => {
                    if (course.module_id !== module_id) return course;
                    return {
                        ...course,
                        lectures: (course.lectures || []).map(lect => {
                            if (lect.lecture_id !== lecture_id) return lect;

                            const newStatus = typeof serverStatus !== 'undefined'
                                ? serverStatus
                                : (lect.lecture_status === 'New' ? 'Not Started' : lect.lecture_status);

                            return {
                                ...lect,
                                lecture_status: newStatus
                            };
                        })
                    };
                }));
                response.data.data.module_id = module_id
                setLectureData(response.data.data);
                setShowSections(module_id)
                setLectureLoading(false)
            })
            .catch(error => {
                viewContext.notification.show("Failed to fetch Data", "error");
                if (error.response.status === 400) {
                    setLectureData({
                        ...lectureData, error: "Failed to Fetch Data"
                    })
                    setLectureLoading(false)
                }
            })
    }

    function onShowSelection(id) {
        if (showSections === id) {
            return setShowSections('')
        }
        setShowSections(id)
    }

    const handlePrevClick = () => {
        setQuesIndex(quesIndex - 1);
    };

    const handleNextClick = () => {
        setQuesIndex(quesIndex + 1);
    };

    const handleTabChange = (event, newTabIndex) => {
        setQuesIndex(newTabIndex);
    };

    const handleSubmit = () => {
        let status = "Completed"
        axios.post(`/api/lms/lectures/quiz/submit?course_id=${courseId}&lecture_id=${lectureData.id}&module_id=${lectureData.module_id}`, {
            answers: selectedAnswers
        })
            .then(response => {
                setIsResults(!isResults);
                setSelectedAnswers(response.data.data.evaluatedAnswers)
                setQuizScore({
                    percentage: response.data.data.percentage,
                    score: response.data.data.userScore
                })

                const moduleId = lectureData?.module_id;
                const lectureId = lectureData?.id;

                setLectureData(prev => ({
                    ...prev, quizStats: {
                        ...prev.quizStats,
                        quizScore: response.data.data.userScore,
                        quizPercentage: response.data.data.percentage,
                        isAttempted: true
                    }
                }));

                if (response.data.data.percentage < 70) {
                    status = "Retake"
                    viewContext.notification.show(
                        "You need at least 70% to complete this quiz. Please retake.",
                        "warning"
                    );
                }
                updateLectureProgress(courseId, moduleId, lectureId, status);
            }).catch(error => {
                viewContext.notification.show("Error submitting quiz", "error");
                // Add error handling code here, such as displaying an error message
            });
    };

    function retakeQuiz() {
        setQuizScore({ showPrevScore: false })
        setIsResults(false);
        setSelectedAnswers([]);
        setQuesIndex(0)

    }

    function iconSelector(type, score) {
        switch (type) {
            case 'video':
            case 'video_ai_transcript':
                return <PlayCircleOutlinedIcon sx={{ color: '#grey' }} />
            case 'youtube_url':
                return <FeatherIcon color='black' icon='youtube' />
            case 'quiz':
                return (
                    <Badge color="success" badgeContent={score}>
                        <FeatherIcon color='black' icon='help-circle' />
                    </Badge>
                )
            case 'document':
                return <AssignmentOutlinedIcon sx={{ color: '#grey' }} />
            default:
                return <AssignmentOutlinedIcon sx={{ color: '#grey' }} />
        }
    }

    // Flatten course structure into a single lecture list
    const allLectures = useMemo(() =>
        courseData.flatMap(module =>
            module.lectures.map(lecture => ({
                moduleId: module.module_id,
                lectureId: lecture.lecture_id,
            }))
        ),
        [courseData]);

    // Current position in the flattened lecture list
    const currentIndex = useMemo(() =>
        allLectures.findIndex(l => l.lectureId === lectureData?.id),
        [allLectures, lectureData]);

    // Navigation state (disables)
    const disableNav = useMemo(() => ({
        prev: currentIndex <= 0,
        next: currentIndex === allLectures.length - 1,
    }), [currentIndex, allLectures]);

    // navigate between lecture
    const moveLecture = (direction) => {
        if (currentIndex === -1) return; // not found / not ready

        const newIndex = currentIndex + (direction === "next" ? 1 : -1);
        if (newIndex < 0 || newIndex >= allLectures.length) return;

        const { moduleId, lectureId } = allLectures[newIndex];
        lectureSelect(moduleId, lectureId);
    };

    function updateLectureProgress(courseId, moduleId, lectureId, status = 'Completed') {
        axios.patch('/api/lms/lectures/status/complete', {
            course_id: courseId,
            module_id: moduleId,
            lecture_id: lectureId,
            status: status
        })
            .then(function (response) {
                setLectureData(prev => ({ ...prev, lecture_status: status, course_activity: response.data.data?.course_activity || prev.course_activity }));
                setCourseData(prevCourseData =>
                    prevCourseData.map(module => {
                        if (module.module_id === moduleId) {
                            let increment = 0;
                            const updatedLectures = module.lectures.map(lecture => {
                                if (lecture.lecture_id === lectureId) {
                                    if (lecture.lecture_status !== status && status === "Completed") {
                                        increment = 1;
                                    }
                                    return { ...lecture, lecture_status: status };
                                }
                                return lecture;
                            });

                            return {
                                ...module,
                                completed_lectures: module.completed_lectures + increment,
                                lectures: updatedLectures
                            };
                        }
                        return module;
                    })
                );

            })
            .catch(function (error) {
                viewContext.notification.show("Error updating lecture status", 'error');
            });
    }

    function handleNav(isLastLectureCompleted = false) {

        // Check the lecture is not Completed and if it is a last lecture of the course and if it is not an last lecture to complete.
        if (lectureData.course_activity?.course_status !== 'Completed' && isLastLecture && !isLastLectureCompleted) {
            setPendingCourse(true);
        }
        updateLectureProgress(courseId, lectureData.module_id, lectureData.id);
    }



    function handleVideoStart() {
        const video_duration = Math.floor(playerRef.current.getDuration());

        if ((video_duration - lectureProgress) > 15) {
            playerRef.current.seekTo(lectureProgress, 'seconds');
            toast.dark('Video playback has resumed from where you left off.', {
                type: 'info',
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            return;
        }
    }

    function postTime(playedSeconds) {

        axios.patch(`/api/lms/lectures/user/progress`, {
            lecture_id: lectureData.id,
            course_id: courseId,
            progress: Math.floor(playedSeconds)
        })
            .then(response => {
                setIsPlaying(playerRef.current.getCurrentTime())
            })
            .catch(error => {
                console.log('err', error)
            })
    }

    const recordProgress = (progress) => {
        const playedSeconds = playerRef.current.getCurrentTime();
        if ((playedSeconds - isPlaying) > 10) {
            postTime(playedSeconds);
        }
    };

    function pauseTime() {
        const time_played = playerRef.current.getCurrentTime();
        postTime(time_played);
    }

    function userManualNavigate(direction) {
        switch (direction) {
            case 'prev':
                setLectureProgress(lectureProgress - 1);
                // postTime(lectureProgress - 1);
                break;
            case 'forward':
                setLectureProgress(lectureProgress + 1);
                postTime(lectureProgress + 1)
                break;
            default:
                break;
        }
    }

    return (
        <>
            <ToastContainer
                id="warning-toast"
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <ConfirmationCard
                title={"Completed Course"}
                body={"There are pending lectures. Please complete all lectures to unlock the certificate."}
                showCard={pendingCourse}
                setShowCard={setPendingCourse}
                handleConfirm={() => { setPendingCourse(false) }}
            />
            <div className={Styles.redirectButtons}>
                <button onClick={() => { lectureData?.type === 'video' && pauseTime(); navigate(`/lms/courses`) }} className={Styles.courseReview}>
                    <FeatherIcon size="0.9em" icon="chevron-left" /> Enrolled Courses
                </button>
                {/* <Tooltip title={isLead && 'Go to the course overview page to edit this course' } arrow placement='left'> */}
                <button onClick={() => { lectureData?.type === 'video' && pauseTime(); navigate(`/lms/courses/${courseId}`) }} className={Styles.courseReview}>
                    Course Overview <FeatherIcon size="0.9em" icon="chevron-right" />
                </button>
                {/* </Tooltip> */}
            </div>

            <LoadingBackdrop isOpen={loading} />
            {data && (<div className={Styles.ancestorContainer}>

                <div className={`${Styles.innerContainer} ${Styles.innerLeftContainer}`}>

                    <List
                        sx={{
                            textAlign: 'center',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            padding: '0.5em 0.2em',
                            height: '100%',
                            maxHeight: '100%'
                        }}
                        subheader={
                            <div style={{ margin: '0.4em 0', fontSize: '0.8em', fontWeight: 600, display: 'flex' }}>
                                Course Contents
                            </div>
                        }
                    >
                        {
                            courseData?.map((module, modIndex) => {
                                return (
                                    <React.Fragment
                                        key={module.module_id}
                                    >
                                        <Divider />
                                        <ListItemButton

                                            onClick={() => { onShowSelection(module.module_id) }}
                                        >
                                            <ListItemText
                                            // primary={module.module_title}
                                            // secondary={
                                            //     <span style={{ display: "flex", alignItems: "center", gap: "0.3em" }}>
                                            //         <span
                                            //             style={{
                                            //                 color:
                                            //                     Math.min(module?.completed_lectures, module?.total_lectures) === module.total_lectures
                                            //                         ? "green"
                                            //                         : "inherit",
                                            //             }}
                                            //         >
                                            //             {`${Math.min(module?.completed_lectures, module?.total_lectures)}/${module?.total_lectures} Lectures`}
                                            //         </span>

                                            //         {Math.min(module.completed_lectures, module.total_lectures) === module.total_lectures && (
                                            //             <DoneIcon fontSize="small" sx={{ color: "black" }} />
                                            //         )}
                                            //     </span>
                                            // }
                                            >

                                                <p style={{ fontSize: '1em', fontWeight: 600 }}>{module?.module_title}</p>
                                            </ListItemText>

                                            {showSections === module?.module_id ? <ExpandLess /> : <ExpandMore />}
                                        </ListItemButton>
                                        <Collapse in={showSections === module?.module_id} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {
                                                    module?.lectures?.map((lecture, secIndex) => {
                                                        return (
                                                            <ListItemButton
                                                                key={`${module.module_id}_${lecture?.lecture_id}`}
                                                                sx={{
                                                                    pl: 4,
                                                                    backgroundColor: (lecture?.lecture_id === lectureData.lecture_id && module?.module_id === lectureData?.module_id) && '#e8e8e8 '
                                                                }}
                                                                onClick={() => { lectureSelect(module?.module_id, lecture?.lecture_id) }}
                                                            >
                                                                <ListItemIcon >
                                                                    {iconSelector(lecture?.lecture_type, lecture?.lecture_score)}
                                                                </ListItemIcon>
                                                                <ListItemText>
                                                                    <p style={{ fontSize: '1em' }}>{lecture.lecture_title}</p>
                                                                </ListItemText>
                                                                {/* {lecture?.lecture_status === 'Completed' && <TaskAltIcon sx={{ color: 'green' }} />} */}
                                                                {lecture?.lecture_status === "Completed" ? (
                                                                    <TaskAltIcon sx={{ color: "green" }} />
                                                                ) : lecture?.lecture_status === "Retake" ? (
                                                                    <ReplayIcon sx={{ color: "orange" }} />
                                                                ) : null}
                                                                {lecture?.lecture_status === 'New' && <p className={Styles.newItem}>NEW</p>}


                                                            </ListItemButton>
                                                        )
                                                    })
                                                }

                                            </List>
                                        </Collapse>
                                    </React.Fragment>
                                )
                            })
                        }
                        {/* <AivagamButton
                            buttonText={`QUIZ`}
                            classStyles={{ width: '8em', padding: "0.4em", margin: '2px auto' }}
                        /> */}
                    </List>

                </div>
                <div className={`${Styles.innerContainer} ${Styles.innerRightContainer}`}>
                    <span className={Styles.titleAndFinish}>
                        <button
                            className={Styles.navArrow}
                            onClick={() => moveLecture("prev")}
                            disabled={disableNav.prev}
                        >
                            <FeatherIcon icon="chevron-left" size="1.2em" />
                        </button>
                        <div className={Styles.centerButtons}>
                            <AivagamButton
                                buttonText={
                                    lectureData?.lecture_status === "Completed"
                                        ? "Completed"
                                        : "Mark as Complete"
                                }
                                classStyles={{ fontSize: "0.7em", padding: "0.5em" }}
                                onClick={() => {
                                    if (lectureData?.lecture_status !== "Completed") {
                                        setHighlightNext(true);
                                        handleNav();
                                        setTimeout(() => setHighlightNext(false), 3000);

                                    }
                                }}
                                disabled={lectureData?.lecture_status === "Completed" || disableNext}
                            />
                            <AivagamButton
                                buttonText="Get Certificate"
                                classStyles={{ fontSize: "0.7em", padding: "0.5em" }}
                                onClick={() => {
                                    navigate(`/lms/courses/${courseId}`);
                                }}
                                disabled={lectureData.course_activity?.course_status !== "completed"}
                            />

                        </div>
                        <button
                            className={`${Styles.navArrow} ${highlightNext ? Styles.highlightArrow : ""}`}
                            onClick={() => {
                                moveLecture("next");
                                setHighlightNext(false);
                            }}
                            disabled={disableNav.next}
                        >
                            <FeatherIcon icon="chevron-right" size="1.2em" />
                        </button>

                    </span>
                    <span className={Styles.titleAndFinish}>
                        <p className={Styles.title} >{lectureData?.title}</p>
                    </span>
                    {
                        (["video", "youtube_url"].includes(lectureData?.type)) &&
                        <div className={Styles.videoContainer}>

                            <ReactPlayer
                                ref={playerRef}
                                className={Styles.videoPlayer}
                                url={lectureData?.type === "youtube_url" ? lectureData?.content : lectureData?.content?.completeUrl}
                                controls={true}
                                onStart={handleVideoStart}
                                onPlay={() => { setIsPlaying(playerRef.current.getCurrentTime()) }}
                                onProgress={recordProgress}
                                onPause={pauseTime}
                                onSeek={pauseTime}
                            />
                        </div>
                    }
                    {
                        (lectureData?.type === 'video_ai_transcript') &&
                        <>
                            <div id='video-container' className={Styles.videoContainer}>
                                <ReactPlayer
                                    ref={playerRef}
                                    className={Styles.videoPlayer}
                                    url={lectureData?.content?.completeUrl}
                                    controls={true}
                                    onStart={handleVideoStart}
                                    onPlay={() => { setIsPlaying(playerRef.current.getCurrentTime()) }}
                                    onProgress={recordProgress}
                                    onPause={pauseTime}
                                    onSeek={pauseTime}
                                />
                            </div>
                            <div id='transcript-container'>
                                <Transcript transcriptData={lectureData?.content?.transcript} playerRef={playerRef} isInteractive={true} />
                            </div>
                        </>
                    }
                    {
                        lectureData?.type === 'document' &&
                        <embed style={{ border: '1px solid #d3d3d3' }} src={lectureData?.content?.completeUrl} width="100%" height="100%" />
                    }
                    {
                        (lectureData?.type === 'quiz') &&
                        <>
                            {quizScore?.showPrevScore ?
                                <div className={Styles.quizContainer}>
                                    <div className={Styles.attemptedQuizScore}>
                                        <div className={Styles.chartContainer}>
                                            <Chart type="donut"
                                                legend={true}
                                                data={{
                                                    "labels": ["Correct", "Wrong"],
                                                    "datasets": [{
                                                        "label": "Percentage",
                                                        "data": [quizScore.percentage, 100 - quizScore.percentage]
                                                    }]
                                                }}

                                                center
                                                color={"gold"}
                                            />
                                        </div>
                                        <div className={Styles.scoreContainer}>
                                            {/* <Typography variant='h3' sx={{fontWeight: 600, textDecoration: 'underline'}}>
                                                Result
                                            </Typography>     */}
                                            <Typography variant='h3'>
                                                {quizScore?.percentage}%
                                                <span style={{ marginLeft: '0.3em', fontSize: '0.4em' }}>[{quizScore?.score} out of {lectureData?.content?.questions?.length}]</span>
                                            </Typography>

                                            <AivagamButton
                                                classStyles={{ width: '8em', borderRadius: '0px ' }}
                                                onClick={() => {
                                                    setQuizScore({ showPrevScore: false })
                                                }}
                                                buttonText={'Retake'}
                                                disabled={quizScore?.percentage >= 70}
                                            />
                                        </div>
                                    </div>

                                </div> :
                                <div style={{ overflowY: 'scroll' }} className={Styles.quizContainer}>
                                    <div className={Styles.quizHeader}>
                                        <Tabs

                                            value={quesIndex}
                                            onChange={handleTabChange}

                                            TabIndicatorProps={{
                                                sx: {
                                                    backgroundColor: '#037d50',
                                                    height: 3,

                                                },
                                            }}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {lectureData?.content?.questions?.map((tablabel, index) => (
                                                <Tab
                                                    key={`${tablabel}_${index}`}
                                                    id={`questionTabs-${index}`}
                                                    label={
                                                        <div
                                                            id={`tabCircle-${index}`}
                                                            className={Styles.tabCircle}
                                                            style={
                                                                !isResults
                                                                    ? {
                                                                        backgroundColor: selectedAnswers[index] !== undefined ? '#4986d6' : '#f2f2f2',
                                                                        color:
                                                                            selectedAnswers[index] !== undefined
                                                                                ? '#fff'
                                                                                : !selectedAnswers[index]?.isAttempted
                                                                                    ? '#000'
                                                                                    : '#f2f2f2'
                                                                    }
                                                                    : {
                                                                        backgroundColor: !selectedAnswers[index]?.isAttempted
                                                                            ? '#f5f5f5'
                                                                            : selectedAnswers[index].isCorrect
                                                                                ? '#18af89'
                                                                                : '#dc6262 ',
                                                                        color: !selectedAnswers[index]?.isAttempted ? '#000' : '#f2f2f2',
                                                                    }
                                                            }

                                                        >
                                                            {index + 1}
                                                        </div>
                                                    }
                                                    sx={{
                                                        fontWeight: '600',
                                                        '&.Mui-selected': {
                                                            color: '#037d50',
                                                        },
                                                    }}
                                                />
                                            ))}
                                        </Tabs>
                                    </div>
                                    {isResults && <div className={Styles.quizScore}>SCORE: {quizScore?.score}/{lectureData?.content?.questions?.length} | PERCENTAGE: {quizScore.percentage}%</div>}
                                    {lectureData?.content?.questions && <span className={Styles.quizComponent}>
                                        <QuizQuestion
                                            key={lectureData?.content?.questions[quesIndex]}
                                            question={isResults ? selectedAnswers[quesIndex] : lectureData?.content?.questions[quesIndex]}
                                            questionNumber={quesIndex + 1}
                                            onAnswerSelect={handleAnswerSelect}
                                            selectedAnswers={selectedAnswers}
                                            Results={isResults}
                                        />
                                    </span>}
                                    <div className={Styles.buttonContainer}>
                                        <span>
                                            <AivagamButton
                                                classStyles={{ width: '8em' }}
                                                onClick={handlePrevClick}
                                                disabled={quesIndex === 0}
                                                buttonText={'Prev'}
                                                showIcon={false}
                                                showResult={false}
                                            />
                                        </span>
                                        <span>
                                            <AivagamButton
                                                classStyles={{ width: '8em' }}
                                                onClick={handleNextClick}
                                                disabled={quesIndex === lectureData?.content?.questions?.length - 1}
                                                buttonText={'Next'}

                                            />
                                        </span>

                                        <span>
                                            <AivagamButton
                                                classStyles={{ width: '8em' }}
                                                onClick={isResults ? retakeQuiz : handleSubmit}
                                                disabled={(selectedAnswers?.length < lectureData?.content?.questions?.length && !isResults) || (isResults && quizScore?.percentage >= 70)}
                                                buttonText={isResults ? 'Retake' : 'Submit'}
                                            />
                                        </span>

                                    </div>
                                </div>
                            }

                        </>
                    }
                    {
                        (lectureData?.type === 'user_manual') &&
                        <div className={Styles.userManualContainer}>
                            <div className={Styles.slideHeader}>
                                <p>SLIDE: {lectureProgress + 1}/{lectureData?.content?.length}</p>
                                <button onClick={() => { setDownloadOpen(!downloadOpen) }}><FeatherIcon icon='download' /></button>
                            </div>
                            <UserManual
                                data={lectureData?.content[lectureProgress]}
                                callback={userManualNavigate}
                                currentIndex={lectureProgress}
                                totalSteps={lectureData?.content?.length}
                            />

                        </div >
                    }
                    <p className={Styles.descriptionPara}>{lectureData?.desc}</p>
                    <div className={Styles.overlay} style={{ display: !lectureLoading && 'none' }}>
                        <CircularProgress color='primary' />
                        Loading
                    </div>
                </div>
            </div >)
            }
            <Dialog
                open={downloadOpen}
                maxWidth={false}
                onClose={() => { setDownloadOpen(!downloadOpen) }}
            >
                <DialogTitle>
                    <ReactToPrint
                        copyStyles={true}
                        content={() => document.getElementById('userManual')}
                        onAfterPrint={() => { setDownloadOpen(!downloadOpen) }}
                        documentTitle='New User Manual'
                    >
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <button
                                    id='confirmDownload'
                                    className={Styles.confirmDownload}
                                    onClick={handlePrint}
                                >
                                    Confirm Download
                                </button>
                            )}
                        </PrintContextConsumer>

                    </ReactToPrint>
                </DialogTitle>
                <DialogContent sx={{ width: '75vw' }} ref={(el) => (reportTemplateRef = el)} className={Styles.printContent} id='userManual'>
                    <p
                        style={{
                            textDecoration: 'underline',
                            fontSize: '1.5rem',
                            fontWeight: 600,
                            textAlign: 'center'
                        }}
                    >
                        {lectureData?.title?.toUpperCase()}
                    </p>
                    {lectureData?.type === 'user_manual' &&
                        lectureData?.content?.map((cont, index) => (
                            <UserManual
                                key={cont.title}
                                data={cont}
                                showNavigate={false}
                                callback={userManualNavigate}
                                currentIndex={lectureProgress}
                                totalSteps={lectureData?.content?.length}
                            />
                        ))}
                </DialogContent>
            </Dialog>
        </>
    )
}

